import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReactiveComponent } from '@schenck/rotec-components';
import { getToolingTaskModalInfos, TaskModalService } from 'src/components';
import { ToolingHistoryModalService } from './tooling-history-modal.service';
import { HistoryModalComponent } from '../../../components/task-modal/history-modal/history-modal.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'ma-tooling-history-modal',
  templateUrl: './tooling-history-modal.component.html',
  styleUrls: ['./tooling-history-modal.component.less'],
  providers: [
    ToolingHistoryModalService,
    { provide: TaskModalService, useExisting: ToolingHistoryModalService },
  ],
  imports: [HistoryModalComponent, AsyncPipe],
})
export class ToolingHistoryModalComponent extends ReactiveComponent {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly translate = inject(TranslateService);
  public taskModalService = inject(ToolingHistoryModalService);

  public state = this.connect(
    getToolingTaskModalInfos(
      this.taskModalService.task$,
      this.taskModalService.tooling$,
      this.taskModalService.plants$,
      this.taskModalService.machines$,
      this.translate
    ),
    this.cdr
  );

  constructor() {
    super();
  }
}
